<template>
	<div class="container pt-5 mb-5">
		<div class="row justify-content-center">
			<div class="col-md-8">

				<label>Category</label>
				<select class="custom-select" v-model="categorySelect" @change="getSubcategories()">
					<option v-for="category in categories" :key="category['.key']" :value="category.slug" >{{ category.name }}</option>
					<option value="" selected disabled>Open this select menu</option>
				</select>
				<div class="alert alert-warning alert-dismissible fade show mt-4" role="alert" v-show="alertSelect">
					<strong>Select category</strong>
				</div>

        <div class="mt-4" v-if=" categorySelect !== '' ">
          <label>Will it have a subcategory?</label>
          <div class="row pl-3">
            <div class="col-md-2 custom-control custom-radio">
              <input type="radio"
                     id="customRadio1"
                     :value="true"
                     name="customRadio"
                     class="custom-control-input"
                     v-model="subcategoryRadio">
              <label class="custom-control-label" for="customRadio1">Yes</label>
            </div>
            <div class="col-md-2 custom-control custom-radio">
              <input type="radio"
                     id="customRadio2"
                     :value="false"
                     name="customRadio"
                     class="custom-control-input"
                     v-model="subcategoryRadio" checked>
              <label class="custom-control-label" for="customRadio2">No</label>
            </div>
          </div>
        </div>

        <div v-show="subcategoryRadio">
          <label class="pt-4">Sub Category</label>
          <select class="custom-select" v-model="subcategorySelect">
            <option v-for="(subcategory, key) in subcategories" :key="key" :value="subcategory.slug">{{ subcategory.name }}</option>
          </select>
        </div>

				<div class="form-group mt-3">
					<label for="file-name">File Name PDF</label>
					<input type="text" class="form-control"
                 id="file-name"
                 name="name"
                 placeholder="File Name"
                 autocomplete="nope"
                 v-validate="'required'"
                 v-model="fileName">
				</div>
				<div class="alert alert-warning alert-dismissible fade show mt-4 mb-4" role="alert" v-show="errors.has('name')">
					<strong>{{ errors.first('name') }}</strong>
				</div>

				<div class="c-upload">
					<input type="file" class="c-upload__input-file" name="file" @change="changeFile" v-validate="'required|ext:pdf'">
					<div class="c-upload__content">
						<font-awesome-icon class="c-upload__icon" :icon="['fal', 'upload']"></font-awesome-icon>
						<h4 class="c-upload__text mt-4">{{ title }}</h4>
					</div>
				</div>
				<div class="alert alert-warning alert-dismissible fade show mt-4" role="alert" v-show="errors.has('file')">
					<strong>{{ errors.first('file') }}</strong>
				</div>

				<div class="progress mt-4" v-if="loader">
					<div class="progress-bar progress-bar-striped progress-bar-animated bg-primary"
               role="progressbar"
               :style="{width: progress + '%'}"
               :aria-valuenow="progress"
               aria-valuemin="0"
               aria-valuemax="100"></div>
				</div>

				<button v-show="buttonUpload" class="btn btn-block btn-primary mt-4 mb-5" @click="uploadFile()">Upload</button>

			</div>
		</div>
	</div>
</template>

<script>
	import { storageFiles, categories } from '../../firebase'
  import { busNotifications } from '../../bus'

	export default {
		data() {
			return {
				title: 'Upload File',
				file: [],
				fileName: '',
        categorySelect: '',
        subcategorySelect: '',
				loader: false,
				progress: 0,
				buttonUpload: false,
        alertSelect: false,
        subcategories: [],
        subcategoryRadio: false
			}
		},
		firestore() {
      return {
        categories: categories.orderBy('priority')
      }
    },
		methods: {
			changeFile(event) {
				this.title = event.target.files[0].name;
				this.file = event.target.files[0];
				event.target.files[0].type === 'application/pdf' ? this.buttonUpload = true : this.buttonUpload = false
      },
      getSubcategories() {
        this.subcategories = [];
        categories.doc(this.categorySelect).collection('subcategories').get().then( docs => {
          docs.forEach( doc => {
            this.subcategories.push( doc.data() )
          })
        })
      },
			uploadFile() {
				this.$validator.validate().then( res => {
					if( res ){

						if( this.categorySelect === ''){
							this.alertSelect = true;
							setTimeout( () => {
								this.alertSelect = false
							}, 2000)
						} else {
							const uploadTask = storageFiles.child('public/files/' + this.title).put(this.file);

							uploadTask.on( 'state_changed', snapshot => {
								let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
								this.progress = progress;
								this.loader = true;

								if(progress >= 100) {
									this.loader = false;
									document.querySelector('.c-upload__input-file').value = ''
								}
							}, error => {
								console.log(error)
							},
							() => {
								uploadTask.snapshot.ref.getDownloadURL().then( downloadURL => {
								  if( this.subcategoryRadio ) {
                    categories.doc(this.categorySelect).collection('subcategories').doc(this.subcategorySelect).collection('files').add({
                        name: this.fileName,
                        fullname: this.title,
                        url: downloadURL
                      });
                  } else {
                    categories.doc(this.categorySelect).collection('uncategorized').add({
                        name: this.fileName,
                        fullname: this.title,
                        url: downloadURL
                      });
                  }
									this.buttonUpload = false;
									this.title = 'Upload File';
									this.categorySelect = '';
									this.fileName = '';
									this.$validator.reset();
                  this.errors.clear();

                  busNotifications.makeNotification('success', 'the file was added correctly')
								})
							})

						}
					}
				})
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/admin/AddFile.vue